import { useState } from 'react';

function useKeywordFilter(initialSelectedFilters) {
  const keywordsFilter = initialSelectedFilters.find(
    (filter) => filter.uid === 'keywords',
  );
  const [keywords, setKeywords] = useState<string[]>(
    keywordsFilter?.value.split(' ') || [],
  );

  const onKeywordRemove = (keyword: string) => {
    setKeywords((prevKeywords) => prevKeywords.filter((k) => k !== keyword));
  };

  const onKeywordAdd = (keyword: string) => {
    if (keywords.includes(keyword)) {
      return;
    }
    setKeywords((prevKeywords) => [...prevKeywords, keyword]);
  };

  return {
    keywords,
    onKeywordRemove,
    onKeywordAdd,
  };
}

export default useKeywordFilter;
